import { Therapy } from '@shared/domain/therapy/therapy.aggregate';
import { httpClient } from '@shared/infrastructure/http/http';
import { TherapyDto } from './dto/therapyDto';
import { configuration } from 'configuration';

export const therapyRepositoryImplementation = {
  getTherapies: async (
    countryCode: string,
    languageCode: string
  ): Promise<Therapy[]> => {
    const response = await httpClient.get<TherapyDto[]>(
      `${configuration.api.baseUrl}/api/${countryCode}/therapies`,
      {
        'Accept-Language': languageCode
      }
    );

    return response as Therapy[];
  },
  toggleEnableTherapy: async (
    therapyId: number,
    countryCode: string
  ): Promise<void> => {
    await httpClient.post(
      `${configuration.api.baseUrl}/api/${countryCode}/therapies/${therapyId}/enabled`,
      {}
    );
  }
};
